import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Preloader = () => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
            }}
        >
            <CircularProgress />
        </Box>
    );
};

export default Preloader;
